import React from 'react'
import {
  AccountTree,
  Inventory,
  Search,
  SupportAgent
} from '@mui/icons-material'

// Only show Faber navlinks
export const VENDOR_NAVLINKS = [
  {
    title: 'Jetpac - Subscription Customers (SG)',
    to: 'manage-customers-faber',
    sub: [],
    flag: '',
    userGroups: ['opsowner', 'opsviewer', 'ops'],
    tooltip: <SupportAgent />
  },
  {
    title: 'Jetpac - One Time Pack Customers (SG)',
    to: 'manage-otpack',
    sub: [],
    flag: '',
    userGroups: ['opsowner', 'opsviewer', 'ops'],
    tooltip: <SupportAgent />
  },
  {
    title: 'Jetpac - Global Customers',
    to: 'manage-global-cx',
    sub: [],
    flag: '',
    userGroups: ['opsowner', 'opsviewer', 'ops'],
    tooltip: <SupportAgent />
  },
  {
    title: 'Jetpac - Terminated customers',
    to: 'manage-terminated-faber',
    sub: [],
    flag: '',
    userGroups: ['opsowner', 'ops', 'opsviewer'],
    tooltip: <SupportAgent />
  },

  {
    title: 'Jetpac - Finance',
    to: 'finance-faber',
    sub: [],
    flag: '',
    userGroups: ['opsowner', 'opsviewer', 'ops'],
    tooltip: <SupportAgent />
  },
  {
    title: 'Jetpac - Search Payments',
    to: 'search-payments',
    sub: [],
    flag: '',
    userGroups: ['opsowner', 'opsviewer', 'ops'],
    tooltip: <Search />
  },

  /* HIDE FOR NOW, ACCESS VIA ROUTE IF NEEDED */
  // {
  //   title: 'Faber - Status',
  //   to: 'status-faber',
  //   sub: [],
  //   flag: '',
  //   userGroups: ['opsowner'],
  //   tooltip: <SupportAgent />
  // },
  {
    title: 'Jetpac - Inventory',
    to: 'manage-inventory-faber',
    sub: [],
    flag: 'esim-inventory',
    userGroups: ['opsowner', 'opsviewer', 'ops'],
    tooltip: <Inventory />
  },
  {
    title: 'Jetpac - Catalogue',
    to: 'manage-catalogue',
    sub: [],
    flag: 'view-catalog-ch',
    userGroups: ['opsowner', 'opsviewer', 'ops'],
    tooltip: <Inventory />
  },
  {
    title: 'Jetpac - Campaign',
    to: 'manage-campaign',
    sub: [],
    flag: '',
    userGroups: ['opsowner', 'opsviewer', 'ops'],
    tooltip: <Inventory />
  },
  {
    title: 'B2B Campaign Management',
    to: 'campaign-management',
    sub: [],
    flag: '',
    userGroups: ['opsowner'],
    tooltip: <Inventory />
  },
  {
    title: 'Jetpac - Rewards',
    to: 'manage-rewards',
    sub: [],
    flag: '',
    userGroups: ['opsowner'],
    tooltip: <Inventory />
  },
  {
    title: 'Jetpac - Vouchers',
    to: 'manage-vouchers',
    sub: [],
    flag: '',
    userGroups: ['opsowner', 'opsviewer', 'ops'],
    tooltip: <Inventory />
  },
  {
    title: 'Jetpac - Whitelist',
    to: 'manage-whitelist',
    sub: [],
    flag: '',
    userGroups: ['opsowner'],
    tooltip: <Inventory />
  },
  {
    title: 'Jetpac - B2B',
    to: 'b2b',
    sub: [
      {
        title: 'TDP Registration',
        to: 'b2b/tdp/registration',
        userGroups: ['opsowner'],
        flag: ''
      },
      {
        title: 'Technology Company',
        to: 'b2b/3ptp',
        userGroups: ['opsowner'],
        flag: ''
      },
      {
        title: 'Catalog Management',
        to: 'b2b/catalog',
        userGroups: ['opsowner'],
        flag:''
      },
      {
        title:"API Out Access Management",
        to: 'b2b/api-out-access',
        userGroups: ['opsowner'],
        flag: ''
      },
      // {
      //   title: 'Order Management',
      //   to: 'b2b/order',
      //   userGroups: ['opsowner'],
      //   flag:''
      // },
      {
        title: 'Wallet Statement',
        to: 'b2b/wallet-statement',
        userGroups: ['opsowner'],
        flag:''
      },
      {
        title:'Customer Statement',
        to: 'b2b/customer-statement',
        userGroups: ['opsowner'],
        flag: ''
      },
      {
        title: 'Pending Payment',
        to: 'b2b/pending-payment',
        userGroups: ['opsowner'],
        flag: ''
      },
      {
        title: 'Wallet Management',
        to: 'b2b/wallet-adjustment',
        userGroups: ['opsowner'],
        flag: ''
      },
      {
        title:'Payment Receipt',
        to: 'b2b/payments',
        userGroups: ['opsowner'],
        flag: ''
      },
      {
        title:'Payment Collection',
        to: 'b2b/payment-collection',
        userGroups: ['opsowner'],
        flag: ''
      },
      {
        title:'User Management',
        to: 'b2b/user-management',
        userGroups: ['opsowner'],
        flag: ''
      }
    ],
    flag: '',
    userGroups: ['opsowner'],
    tooltip: <Inventory />
  },
  {
    title: 'Jetpac - External Platforms',
    to: 'manage-external-platforms',
    sub: [],
    flag: '',
    userGroups: ['opsowner'],
    tooltip: <Inventory />
  },
  {
    title: 'Manage Ops Accounts',
    to: 'manage-accounts',
    sub: [],
    flag: '',
    userGroups: ['opsowner'],
    tooltip: <AccountTree />
  },
  {
    title: 'External - Users',
    to: 'manage-external-users',
    sub: [],
    flag: '',
    userGroups: ['opsowner', 'external'],
    tooltip: <SupportAgent />
  }
]
